<template>
  <v-dialog v-model="dialog" width="500" persistent>
    <template v-slot:activator="{ on, attrs }">
      <v-btn color="primary" v-bind="attrs" v-on="on">اضافة معاملة</v-btn>
    </template>
    <v-card>
      <v-card-title>اضافة معاملة</v-card-title>
      <v-card-text>
        <v-alert
          v-if="success"
          color="green"
          class="text-center font-weight-bold text--black"
        >
          تمت اضافة المعاملة بنجاح
        </v-alert>
        <v-form ref="form">
          <div class="d-flex align-center">
            <v-select
              v-model="type"
              outlined
              item-text="text"
              item-value="value"
              dense
              :items="transType"
              class="me-3"
              style="max-width: 100px"
            >
            </v-select>
            <v-text-field
              :rules="[(v) => !!v || 'חובה']"
              type="number"
              outlined
              dense
              class="my-4"
              label="סכום"
              v-model="amount"
            />
          </div>
          <v-textarea
            outlined
            dense
            class="my-4"
            label="سبب المعاملة"
            v-model="description"
            hide-details
          />
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn
          :disabled="save_loader"
          :loading="save_loader"
          color="primary"
          @click="save()"
          >اضافة</v-btn
        >
        <v-btn color="black white--text" @click="dialog = false">اغلاق</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "TransactionForm",
  data() {
    return {
      dialog: false,
      amount: 0,
      description: null,
      save_loader: false,
      success: false,
      type: "+",
    };
  },
  computed: {
    transType() {
      return [
        {
          text: "ناقص",
          value: "-",
        },
        {
          text: "اضافة",
          value: "+",
        },
      ];
    },
  },
  watch: {
    type(newVal, oldVal) {
      if (newVal === "-") {
        this.amount = Math.abs(this.amount) * -1;
      } else {
        this.amount = Math.abs(this.amount);
      }
    },
  },
  methods: {
    save() {
      if (this.$refs.form.validate() && !this.save_loader) {
        this.save_loader = true;
        this.success = false;
        this.$store
          .dispatch("public__request", {
            config: {
              url: `delivery-transactions/${this.$route.params.id}`,
              method: "post",
            },
            data: {
              amount: this.amount,
              description: this.description,
            },
          })
          .then((res) => {
            this.success = true;

            this.$emit("update_data");
            setTimeout(() => {
              this.dialog = false;
              this.save_loader = false;
              this.success = false;
            }, 1000);
          })
          .catch((err) => {
            this.save_loader = false;
            this.success = false;
          });
      }
    },
  },
};
</script>
